// extracted by mini-css-extract-plugin
export default {"header":"Header_header__q9XN9","main-image":"Header_main-image__8vT+a"};